var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecoverySuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#A3CFBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4168 34.8517V36.5C53.4146 40.3636 52.1636 44.123 49.8502 47.2175C47.5369 50.312 44.2852 52.5757 40.5802 53.6712C36.8751 54.7667 32.9153 54.6351 29.2911 53.2962C25.6669 51.9572 22.5727 49.4826 20.4698 46.2415C18.3669 43.0003 17.3681 39.1662 17.6223 35.3109C17.8765 31.4557 19.3702 27.786 21.8804 24.849C24.3907 21.912 27.7831 19.8651 31.5517 19.0136C35.3203 18.1622 39.2631 18.5517 42.7923 20.1242",
    stroke: "#37B772",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4167 22.1666L35.5 40.1012L30.125 34.7262",
    stroke: "#37B772",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverySuccess);
export default __webpack_public_path__ + "static/media/recovery-success.a20981ed654f9dec30e2c8c0b2895bb1.svg";
export { ForwardRef as ReactComponent };